<template>
  <div>
    <div v-show="currTab == 0">
      <my-index ref="index" :venuesList="venuesList"></my-index>
    </div>
    <div v-show="currTab == 1">
      <my-order ref="order"></my-order>
    </div>
    <div v-show="currTab == 2">
      <my-info ref="info"></my-info>
    </div>
    <div class="bottom-bar d-around">
      <div
        class="d-column d-aligncnter"
        @click="changeTab(index)"
        v-for="(item, index) in tabList"
        :key="'tab_' + index"
        style="width: 33.3%"
      >
        <img :src="item.activeImg" v-show="currTab == index" />
        <img :src="item.greyImg" v-show="currTab != index" />
        <div :class="currTab == index ? 'green' : 'grey'">{{ item.name }}</div>
      </div>
      <!-- <div class="d-column d-aligncnter" @click="currTab = 0">
        <img src="@/assets/img/appointment/home-active.svg" v-show="currTab == 0" />
        <img src="@/assets/img/appointment/home-grey.svg" v-show="currTab != 0" />
        <div :class="currTab == 0 ? 'green' : 'grey'">主页</div>
      </div>
      <div class="d-column d-aligncnter" @click="currTab = 1">
        <img src="@/assets/img/appointment/shopping-active.svg" v-show="currTab == 1" />
        <img src="@/assets/img/appointment/shopping-grey.svg" v-show="currTab != 1" />
        <div :class="currTab == 1 ? 'green' : 'grey'">我的预约</div>
      </div>
      <div class="d-column d-aligncnter" @click="currTab = 2">
        <img src="@/assets/img/appointment/setting-active.svg" v-show="currTab == 2" />
        <img src="@/assets/img/appointment/setting-grey.svg" v-show="currTab != 2" />
        <div :class="currTab == 2 ? 'green' : 'grey'">账号设置</div>
      </div> -->
    </div>
  </div>
</template>
<script>
import MyInfo from './components/MyInfo'
import MyOrder from './components/MyOrder'
import MyIndex from './components/MyIndex'
import { getVenueProfileList } from '@/api/api-venueOrder'
export default {
  components: {
    MyInfo,
    MyOrder,
    MyIndex,
  },
  data() {
    return {
      currTab: 0,
      venuesList: [],
      tabList: [
        {
          name: '主页',
          activeImg: require('@/assets/img/appointment/home-active.svg'),
          greyImg: require('@/assets/img/appointment/home-grey.svg'),
        },
        {
          name: '我的预约',
          activeImg: require('@/assets/img/appointment/shopping-active.svg'),
          greyImg: require('@/assets/img/appointment/shopping-grey.svg'),
        },
        {
          name: '账号设置',
          activeImg: require('@/assets/img/appointment/setting-active.svg'),
          greyImg: require('@/assets/img/appointment/setting-grey.svg'),
        },
      ],
    }
  },
  mounted() {
    this.getVenueProfileListData()
    // const that = this
    this.$on('teston', function () {
      console.log('teston???')
    })
  },
  activated() {
    console.log('activated???')
    setTimeout(() => {
      this.$refs.order.$emit('keepDataOrder')
      this.$refs.index.$emit('keepDataIndex')
    }, 100)
  },
  methods: {
    changeTab(index) {
      this.currTab = index
      if (index == 2) {
        console.log('changeTab:', index)
        setTimeout(() => {
          //   this.$ref.info.getInfoData()
          this.$refs.info.$emit('getInfoData')
        }, 500)
      }
      if (index == 1) {
        console.log('changeTab:', index)
        setTimeout(() => {
          this.$refs.order.$emit('getMyConferenceData')
        }, 500)
      }
    },
    getVenueProfileListData() {
      getVenueProfileList().then((res) => {
        if (res.data.statusCode == 1) {
          this.venuesList = res.data.obj
        }
      })
    },
  },
}
</script>
<style lang="scss" scoped>
@import '@/assets/css/appoint.scss';
.model {
  width: 72px;
  height: 72px;
  border-radius: 8px;
  background: #fff;
  box-shadow: 2.801px 8.403px 31.122px -4.046px rgba(22, 52, 80, 0.1);
  margin-top: 16px;
  color: #464646;
}
.mt-16 {
  margin-top: 16px;
}
.venues-each {
  width: 347px;
  height: 192px;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
  margin: 8px;
  .bg-color {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background: linear-gradient(90deg, #002417 0.15%, rgba(0, 122, 77, 0) 54.73%);
  }
  img {
    width: 100%;
  }
}
.venues-info {
  position: absolute;
  top: 16px;
  left: 16px;
  z-index: 99;
  color: #fff;
  font-size: 14px;
}
</style>
